import { FormWithRedux } from '../../FormWithRedux';

import { ACCBISTPupilAssessmentForm } from './ACCSBIST-PupilAssessmentForm'; 
import { FormValidationError } from '../../../waferJS/Form/Validation/FormValidationError';
import { FormValidation } from '../../../waferJS/Form/Validation/FormValidation';
import { FormsStyles, FormsUIGlossary } from '../../../waferJS/FormsUI/FormsUI';
import { ACCBISTGCSForm } from './ACCBIST-GCSForm';

export class ACCBISTNeuroObsForm extends FormWithRedux {

    constructor(parent, actionUpdater, dependentValuesUpdater, calculationsUpdater) {
        super('gcsSubform', parent, actionUpdater, dependentValuesUpdater, calculationsUpdater);
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'pupilAssessmentSubform':
                return new ACCBISTPupilAssessmentForm(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
            case 'gcsSectionSubform':
                return new ACCBISTGCSForm(this, this.actionUpdater, this.dependentValuesUpdater, this.calculationsUpdater);
        }
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory(identifier) {
        if (identifier == 'neuroObsOkayCheck') {
            return this.getValue('neuroObsOkayCheck') == true;
        }

        let allFineCheck = this.getValue('neuroObsOkayCheck');
        
        if (allFineCheck != null && allFineCheck != undefined && allFineCheck == true) {
            return false;
        } 
        
        return true;
    }

    getValueType(identifier) {
        if (identifier == 'neuroObsOkayCheck') {
            return 'boolean';
        }
        else if (identifier == 'neuroObsDateTime') {
            return 'date';
        }
        
        return null;
    }

    submissionValidation() {
        return [];
    }

    editingValidation(identifier) {
        if (identifier == 'neuroObsOkayCheck') {
            let self = this;
    
            let valueConflict = new FormValidation('AbnormalitiesPresentConflict', function () {
                let noIssuesCheck = self.getValue('neuroObsOkayCheck');

                let leftEyeSize = self.getValue('leftPupilSize');
                let leftEyeState = self.getValue('leftPupilReaction');
                let rightEyeSize = self.getValue('rightPupilSize');
                let rightEyeState = self.getValue('rightPupilReaction');

                if (noIssuesCheck == true && leftEyeSize != null & leftEyeSize != undefined && leftEyeSize != null & leftEyeSize != undefined && leftEyeSize != rightEyeSize) {
                    return [new FormValidationError(FormValidationError.FormErrorType.error, 'Pupils are not symmetrical')];
                }
                else if (noIssuesCheck == true && leftEyeState != null & leftEyeState != undefined && rightEyeState != null & rightEyeState != undefined && (leftEyeState != 'Reacts briskly' || rightEyeState != 'Reacts briskly')) {
                    return [new FormValidationError(FormValidationError.FormErrorType.error, 'Pupil reaction is not normal')];
                }
                else {
                    return [];
                }
            });

            return [valueConflict];
        }

        return [];
    }

    getBadgeValue(identifier) {
        if (identifier == 'totalGCSScore') {
            let value = this.getValue('totalGCS');

            if (value != null && value != undefined) {
                return [{
                    color: FormsStyles.black,
                    title: 'Total GCS',
                    value: value.toString(),
                    solid: false
                }];
            }
            else {
                return [];
            }
        }

        return [];
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Forms/ACCBIST-NeuroObsForm.js